'use client';

import React from 'react';
import classNames from 'classnames';
import { ServicesBlock } from '@sapientpro/sapientpro-data-models';
import styles from './ServiceBlock.module.scss';
import Service from './Service';
import ServiceCase from './ServiceCase';
import AnimatedTitle from '../../../components/AnimatedTitle';

interface IProps {
  servicesBlock: ServicesBlock;
}

const ServiceBlock = ({ servicesBlock }: IProps) => (
  <div className={styles.serviceBlock}>
    <div className={styles.textContainer}>
      <div className={styles.sectionWrapper}>
        <h3 className={classNames('sectionTitle', styles.title)}>
          <AnimatedTitle title={servicesBlock?.title} />
        </h3>
      </div>
      <p className={styles.text}>{servicesBlock.description}</p>
    </div>

    <div className={styles.servicesList}>
      {servicesBlock?.content?.map((content) => {
        const {
          service,
          case: serviceCase,
          image,
          serviceTitle,
          serviceDescription,
          caseTitle,
          caseDescription,
        } = content;

        return (
          <div
            className={styles.serviceContainer}
            key={content.id}
          >
            <Service
              service={service}
              serviceTitle={serviceTitle}
              serviceDescription={serviceDescription}
            />
            <ServiceCase
              caseTitle={caseTitle}
              caseDescription={caseDescription}
              serviceCase={serviceCase}
              image={image}
            />
            <div className={styles.bottomLine} />
          </div>
        );
      })}
    </div>
  </div>
);

export default ServiceBlock;
